import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from "@material-ui/core/Grid/Grid";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbContactCalloutBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`contact-callout ${props.attributes.className ? props.attributes.className : ''} ${classes.contactCalloutTheme} ${classes.contactCallout}`}>
        <Grid container spacing={3} direction="row">
            <Grid item xs={12} md={6} className="text">
                {blocks.map((block) => {
                    return block;
                })}
            </Grid>
            <Grid item xs={12} md={6} className="buttons">
                {blocks.map((block) => {
                    return block;
                })}
            </Grid>
        </Grid>
    </div>
};

export const CgbContactCalloutBlockFragment = graphql`
  fragment CgbContactCalloutBlock on WpBlock {
    ... on WpCgbContactCalloutBlock {
        name
        attributes {
            ... on WpCgbContactCalloutBlockAttributes {
                className
            }
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbContactCalloutBlockPreview = `
    ... on CgbContactCalloutBlock {
        name
        attributes {
            ... on CgbContactCalloutBlockAttributes {
                className
            }
        }
    }
`;